import { createSlice } from "@reduxjs/toolkit";

function InitState() {
  const initialState = {};
  initialState.content = null;
  initialState.contentMetadata = null;
  initialState.contentModel = null;
  initialState.socialConnections = null;
  return initialState;
}

export const contentDataSlice = createSlice({
  name: "contentData",
  initialState: InitState(),
  reducers: {
    initState: (state, action) => {
      const payload = action.payload;
      state.content = payload.content;
      state.contentMetadata = payload.contentMetadata;
      state.contentModel = payload.contentModel;
      state.socialConnections = payload.socialConnections;
    },

    /** Merge one content item after create/update so admin forms see saved fields immediately. */
    upsertItem: (state, action) => {
      const doc = action.payload;
      if (!doc || typeof doc !== "object" || !state.content) return;
      const key =
        (doc._id != null && String(doc._id)) ||
        (doc.identifier != null && String(doc.identifier)) ||
        "";
      if (!key) return;

      let storeKey = key;
      if (!state.content[storeKey]) {
        const match = Object.entries(state.content).find(([, item]) => {
          if (!item) return false;
          return (
            String(item._id) === key ||
            String(item.identifier) === key ||
            String(item.identifier) === String(doc.identifier) ||
            String(item._id) === String(doc._id)
          );
        });
        if (match) storeKey = match[0];
      }

      state.content[storeKey] = {
        ...(state.content[storeKey] || {}),
        ...doc,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const contentDataActions = contentDataSlice.actions;

export default contentDataSlice.reducer;
